import gql from 'graphql-tag';

export const GIF_SEARCH_QUERY = gql`
    query GifSearch($query: String!, $offset: Int!) {
        gifSearch(query: $query, offset: $offset) {
            gifUrl
            previewUrl
        }
    }
`;
